import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { Col, Row, FormGroup, Label, Input, Spinner } from 'reactstrap';
import { Search, ChevronDown, ChevronUp } from 'react-feather';
import PropTypes from 'prop-types';
import alumnosApiService from '../../services/http/alumnosApiService';
import envioEmailService from '../../services/http/envioEmailService';
import { EMAIL_GROUPS } from '../../helpers/constants';
import logger from '../../services/logger';
import colors from '../../theme/colors';

const FiltrarAlumnos = ({
  setAlumnos,
  setIsLoading,
  emailGroup,
  setEmailGroup,
  isLoading,
  setSelectedEmails,
  filters,
  setFilters,
}) => {
  const { empresaId, idFormationCenter, group } = filters;
  const [showFilters, setShowFilters] = useState(true);
  const [formationCenter, setFormationCenter] = useState([]);
  const [groupList, setGroupList] = useState([]);

  useEffect(() => {
    const cargarOpciones = async () => {
      try {
        const dataCentros = await alumnosApiService.cargarCentrosFormacion({ empresaId });
        setFormationCenter(dataCentros.map((centro) => ({ value: centro.Id, label: centro.Nombre })));
      } catch (error) {
        setFormationCenter([]);
      }

      try {
        const dataCentros = await envioEmailService.consultaGrupos({ headquarter: empresaId });
        setGroupList(dataCentros.map((centro) => ({ value: centro.codigogrupo, label: centro.descripcion2 })));
      } catch (error) {
        logger.error('Error fetching grupos:', error);
        setGroupList([]);
      }
    };

    cargarOpciones();
  }, [empresaId]);

  const handleEmpresaChange = (e) => {
    setFilters((prev) => ({ ...prev, empresaId: e.target.value, idFormationCenter: [], group: [] }));
  };

  const CustomClearText = () => 'borrar todo';

  const ClearIndicator = (props) => {
    const {
      children = <CustomClearText />,
      getStyles,
      innerProps: { ref, ...restInnerProps },
    } = props;

    return (
      <div {...restInnerProps} ref={ref} style={getStyles('clearIndicator', props)}>
        <div style={{ padding: '0px 5px' }}>{children}</div>
      </div>
    );
  };

  ClearIndicator.propTypes = {
    children: PropTypes.node,
    getStyles: PropTypes.func.isRequired,
    innerProps: PropTypes.shape({ ref: PropTypes.oneOfType([PropTypes.func, PropTypes.object]) }).isRequired,
  };

  const handleOnClick = async () => {
    setIsLoading(true);
    setSelectedEmails({});
    try {
      const dataAlumnos = await envioEmailService.consultaAlumnosFiltrados({
        headquarter: empresaId,
        listadoCentros: idFormationCenter.map((e) => e.value),
        listadoGrupos: group.map((e) => e.value),
      });
      setAlumnos(dataAlumnos);
    } catch (error) {
      logger.error('Error fetching grupos:', error);
      setAlumnos([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEmailGroupChange = (selection) => setEmailGroup(selection);

  return (
    <div style={{
      backgroundColor: '#fff', borderRadius: '12px',
      border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgb(0 0 0 / 0.06)',
      overflow: 'visible', marginBottom: '16px',
    }}>
      {/* Toolbar */}
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '12px 16px',
        borderBottom: showFilters ? '1px solid #f3f4f6' : 'none',
      }}>
        <button
          type="button"
          onClick={() => setShowFilters(!showFilters)}
          style={{
            display: 'flex', alignItems: 'center', gap: '6px',
            background: 'none', border: 'none', cursor: 'pointer',
            fontSize: '0.8rem', fontWeight: 600, color: '#374151',
            padding: '4px 8px', borderRadius: '6px',
          }}
        >
          <Search size={15} style={{ color: '#9ca3af' }} />
          Filtros
          {showFilters
            ? <ChevronUp size={14} style={{ color: '#9ca3af' }} />
            : <ChevronDown size={14} style={{ color: '#9ca3af' }} />}
        </button>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button
            type="button"
            onClick={handleOnClick}
            disabled={isLoading}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 14px',
              fontSize: '0.75rem', fontWeight: 600, borderRadius: '6px', border: 'none',
              backgroundColor: colors.primary, color: '#fff',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              opacity: isLoading ? 0.5 : 1, transition: 'all 0.15s',
            }}
          >
            {isLoading ? <Spinner style={{ height: '13px', width: '13px' }} /> : <Search size={13} />}
            {isLoading ? 'Buscando...' : 'Filtrar'}
          </button>
        </div>
      </div>

      {/* Filtros colapsables */}
      {showFilters && (
        <div style={{
          padding: '16px',
          opacity: isLoading ? 0.5 : 1,
          pointerEvents: isLoading ? 'none' : 'auto',
          transition: 'opacity 0.2s',
        }}>
          <Row className="mb-3">
            <Col md="4">
              <FormGroup>
                <Label for="centroSelect">Centro</Label>
                <Input type="select" name="centro" id="centroSelect" value={empresaId} onChange={handleEmpresaChange}>
                  <option value="CEDESCA">Cedesca</option>
                  <option value="CNTEC">Cntec</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <Label for="delegacionSelect">Delegación</Label>
                <Select
                  value={idFormationCenter} closeMenuOnSelect={false} options={formationCenter}
                  isMulti components={{ ClearIndicator }}
                  onChange={(selection) => setFilters((prev) => ({ ...prev, idFormationCenter: selection }))}
                  placeholder="Seleccionar..."
                />
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <Label for="grupoSelect">Grupo</Label>
                <Select
                  value={group} closeMenuOnSelect={false} options={groupList}
                  isMulti onChange={(selection) => setFilters((prev) => ({ ...prev, group: selection }))}
                  components={{ ClearIndicator }}
                  placeholder="Seleccionar..."
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="4">
              <FormGroup>
                <Label for="emailGroup">Grupo email</Label>
                <Select
                  value={emailGroup} closeMenuOnSelect={false}
                  options={[
                    { value: EMAIL_GROUPS.PERSONAL, label: 'Email personal' },
                    { value: EMAIL_GROUPS.CENTRO, label: 'Email centro' },
                    { value: EMAIL_GROUPS.TUTOR1, label: 'Email tutor 1' },
                    { value: EMAIL_GROUPS.TUTOR2, label: 'Email tutor 2' },
                  ]}
                  isMulti onChange={handleEmailGroupChange} components={{ ClearIndicator }}
                  placeholder="Seleccionar..."
                />
              </FormGroup>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

FiltrarAlumnos.propTypes = {
  filters: PropTypes.object,
  setFilters: PropTypes.func,
  setAlumnos: PropTypes.func,
  setIsLoading: PropTypes.func,
  emailGroup: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  setEmailGroup: PropTypes.func,
  isLoading: PropTypes.bool,
  setSelectedEmails: PropTypes.func,
};

export default FiltrarAlumnos;
